export const usersMessages = {
  en: {
    userInfo: {
      pageTitle: 'Settings',
      pageSubtitle: 'Manage your profile, appearance and security settings.',
      title: 'Profile Information',
      companyTitle: 'Company',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      emailReadOnly: 'Email address cannot be changed here.',
      avatarUrl: 'Avatar URL',
      companyName: 'Company Name',
      companyDescription: 'Company Description',
      readOnlyBadge: 'Read-only',
      companyReadOnlyNote: 'Company data is managed by your administrator.',
      saveBtn: 'Save Changes',
      loadFailed: 'Failed to fetch user data.',
      saveFailed: 'Failed to update profile.',
      saved: 'Profile updated.',
    },
    passwordChange: {
      title: 'Security',
      oldPassword: 'Current Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm New Password',
      changeBtn: 'Change Password',
      saved: 'Password changed successfully.',
      saveFailed: 'Failed to change password.',
      oldPasswordWrong: 'The current password is incorrect.',
      passwordMismatch: 'Passwords do not match.',
      minLength: 'Password must be at least 8 characters.',
    },
    userSettings: {
      title: 'Appearance',
      colorModeLabel: 'Color Mode',
      colorModePlaceholder: 'Select Color Mode',
      colorModeLight: 'Light',
      colorModeDark: 'Dark',
      autoSaveNote: 'Changes are applied immediately.',
      saved: 'Settings saved.',
      saveFailed: 'Failed to save settings.',
    },
    toolsGlobal: {
      title: 'Top Tools (global)',
      filtersTitle: 'Filters',
      filterReset: 'Reset filters',
      filterCategoryLabel: 'Category',
      filterCategoryPlaceholder: 'All categories',
      filterCategoryAll: 'All',
      colTool: 'Tool',
      colCategory: 'Category',
      colGroups: 'Groups',
      colLinks: 'Links',
      colLastUsed: 'Last Used',
      noTools: 'No tools available.',
      loadFailed: 'Tools could not be loaded.',
      filterGroupLabel: 'Hacker Group',
      filterGroupPlaceholder: 'All groups',
      chipGroup: 'Group',
      statsCategories:  'Categories',
      statsTopGroups:   'Groups by Tool Count',
      statsTopTools:    'Most-Used Tools',
      statsOther:       'Other',
      statsLoadFailed:  'Stats could not be loaded.',
    },
    apiKeys: {
      title: 'API Keys',
      subtitle: 'Create personal API keys for programmatic or MCP access. Keys inherit your permissions — you can restrict them further.',
      addBtn: 'New API Key',
      colLabel: 'Label',
      colPrefix: 'Prefix',
      colScopes: 'Scopes',
      colStatus: 'Status',
      colCreated: 'Created',
      colLastUsed: 'Last Used',
      colExpires: 'Expires',
      statusActive: 'Active',
      statusRevoked: 'Revoked',
      statusExpired: 'Expired',
      revokeTooltip: 'Revoke',
      confirmRevoke: 'Really revoke this API key? This cannot be undone.',
      revoked: 'Revoked',
      keyRevoked: 'API key revoked.',
      revokeFailed: 'Failed to revoke the API key.',
      dialogCreate: 'New API Key',
      formLabel: 'Label (optional)',
      formLabelPlaceholder: 'e.g. My Integration',
      formScopes: 'Scopes',
      formScopesHint: 'Select which permissions this key should have. Defaults to all your permissions.',
      formExpires: 'Expiry Date (optional)',
      selectAll: 'Select all',
      deselectAll: 'Deselect all',
      mcpPreset: 'MCP preset',
      mcpPresetHint: 'Applies the recommended read-only scopes for MCP clients.',
      createBtn: 'Create Key',
      created: 'Created',
      keyCreated: 'API key created.',
      createFailed: 'Failed to create API key.',
      dialogCreated: 'Copy your API Key',
      plainKeyHint: '<strong>This key is shown only once.</strong> Copy it now — it cannot be retrieved later.',
      copyBtn: 'Copy to Clipboard',
      copied: 'Copied',
      keyCopied: 'Key copied to clipboard.',
      copyFailed: 'Could not copy. Please copy manually.',
      closeBtn: 'Close',
      loadFailed: 'Failed to load API keys.',
      scopesLoadFailed: 'Failed to load available scopes.',
      empty: 'No API keys yet.',
    },
  },
  de: {
    userInfo: {
      pageTitle: 'Einstellungen',
      pageSubtitle: 'Verwalte dein Profil, Darstellung und Sicherheitseinstellungen.',
      title: 'Profilinformationen',
      companyTitle: 'Unternehmen',
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'E-Mail',
      emailReadOnly: 'E-Mail-Adresse kann hier nicht geändert werden.',
      avatarUrl: 'Avatar URL',
      companyName: 'Unternehmensname',
      companyDescription: 'Unternehmensbeschreibung',
      readOnlyBadge: 'Nur Lesen',
      companyReadOnlyNote: 'Unternehmensdaten werden vom Administrator verwaltet.',
      saveBtn: 'Änderungen speichern',
      loadFailed: 'Benutzerdaten konnten nicht geladen werden.',
      saveFailed: 'Profil konnte nicht aktualisiert werden.',
      saved: 'Profil gespeichert.',
    },
    passwordChange: {
      title: 'Sicherheit',
      oldPassword: 'Aktuelles Passwort',
      newPassword: 'Neues Passwort',
      confirmPassword: 'Neues Passwort bestätigen',
      changeBtn: 'Passwort ändern',
      saved: 'Passwort erfolgreich geändert.',
      saveFailed: 'Passwort konnte nicht geändert werden.',
      oldPasswordWrong: 'Das aktuelle Passwort ist nicht korrekt.',
      passwordMismatch: 'Passwörter stimmen nicht überein.',
      minLength: 'Passwort muss mindestens 8 Zeichen lang sein.',
    },
    userSettings: {
      title: 'Darstellung',
      colorModeLabel: 'Anzeigemodus',
      colorModePlaceholder: 'Anzeigemodus wählen',
      colorModeLight: 'Hell',
      colorModeDark: 'Dunkel',
      autoSaveNote: 'Änderungen werden sofort übernommen.',
      saved: 'Einstellungen gespeichert.',
      saveFailed: 'Einstellungen konnten nicht gespeichert werden.',
    },
    toolsGlobal: {
      title: 'Top Tools (global)',
      filtersTitle: 'Filter',
      filterReset: 'Filter zurücksetzen',
      filterCategoryLabel: 'Kategorie',
      filterCategoryPlaceholder: 'Alle Kategorien',
      filterCategoryAll: 'Alle',
      colTool: 'Tool',
      colCategory: 'Kategorie',
      colGroups: 'Gruppen',
      colLinks: 'Links',
      colLastUsed: 'Letzte Nutzung',
      noTools: 'Keine Tools vorhanden.',
      loadFailed: 'Tools konnten nicht geladen werden.',
      filterGroupLabel: 'Hacker-Gruppe',
      filterGroupPlaceholder: 'Alle Gruppen',
      chipGroup: 'Gruppe',
      statsCategories:  'Kategorien',
      statsTopGroups:   'Gruppen nach Tool-Anzahl',
      statsTopTools:    'Meistgenutzte Tools',
      statsOther:       'Sonstige',
      statsLoadFailed:  'Statistiken konnten nicht geladen werden.',
    },
    apiKeys: {
      title: 'API Keys',
      subtitle: 'Erstelle persönliche API Keys für programmatischen oder MCP-Zugriff. Keys erben deine Berechtigungen — du kannst sie weiter einschränken.',
      addBtn: 'Neuer API Key',
      colLabel: 'Bezeichnung',
      colPrefix: 'Prefix',
      colScopes: 'Berechtigungen',
      colStatus: 'Status',
      colCreated: 'Erstellt',
      colLastUsed: 'Zuletzt verwendet',
      colExpires: 'Läuft ab',
      statusActive: 'Aktiv',
      statusRevoked: 'Widerrufen',
      statusExpired: 'Abgelaufen',
      revokeTooltip: 'Widerrufen',
      confirmRevoke: 'API Key wirklich widerrufen? Das kann nicht rückgängig gemacht werden.',
      revoked: 'Widerrufen',
      keyRevoked: 'API Key wurde widerrufen.',
      revokeFailed: 'API Key konnte nicht widerrufen werden.',
      dialogCreate: 'Neuer API Key',
      formLabel: 'Bezeichnung (optional)',
      formLabelPlaceholder: 'z.B. Meine Integration',
      formScopes: 'Berechtigungen',
      formScopesHint: 'Wähle welche Berechtigungen dieser Key haben soll. Standardmäßig werden alle deine Berechtigungen vergeben.',
      formExpires: 'Ablaufdatum (optional)',
      selectAll: 'Alle auswählen',
      deselectAll: 'Alle abwählen',
      mcpPreset: 'MCP-Preset',
      mcpPresetHint: 'Setzt die empfohlenen Lesezugriffe für MCP-Clients.',
      createBtn: 'Key erstellen',
      created: 'Erstellt',
      keyCreated: 'API Key wurde erstellt.',
      createFailed: 'API Key konnte nicht erstellt werden.',
      dialogCreated: 'API Key kopieren',
      plainKeyHint: '<strong>Dieser Key wird nur einmal angezeigt.</strong> Kopiere ihn jetzt — er kann später nicht mehr abgerufen werden.',
      copyBtn: 'In Zwischenablage kopieren',
      copied: 'Kopiert',
      keyCopied: 'Key in Zwischenablage kopiert.',
      copyFailed: 'Kopieren fehlgeschlagen. Bitte manuell kopieren.',
      closeBtn: 'Schließen',
      loadFailed: 'API Keys konnten nicht geladen werden.',
      scopesLoadFailed: 'Verfügbare Berechtigungen konnten nicht geladen werden.',
      empty: 'Noch keine API Keys vorhanden.',
    },
  },
}
